<template>
  <div v-if="show" :class="[$style.modal, wide && $style.wide]">
    <div :class="$style.content">
      <slot name="icon" :class="$style.slot_icon"></slot>
      <h1 :class="$style.title">{{title}}</h1>
      <span :class="$style.description" v-if="description">{{description}}</span>
      <slot name="description" :class="$style.description"></slot>
      <div v-if="steps" :class="$style.steps">
        <div :class="$style.step" v-for="(step, index) in steps" :key="step">
          <span :class="$style.step__number">{{index+1}}</span>
          <span :class="$style.step__description">{{step}}</span>
        </div>
      </div>
      <div v-if="showPoints" :class="$style.points">
        <span :class="$style.points__title">Ты набрал</span>
        <span :class="$style.points__number">{{points}}</span>
        <span :class="$style.points__measure">Баллов</span>
      </div>
      <div :class="$style.buttons">
        <button :class="$style.closeButton" @click="buttonClick">{{buttonText}}</button>
        <button v-if="showShare || showPoints" :class="[$style.closeButton, $style.shareButton]" @click="shareButtonClick">Поделиться в VK</button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'LevelPopup',
  props: {
    title: String,
    description: String,
    icon: String,
    steps: Array,
    showPoints: Boolean,
    showShare: Boolean,
    numberOfPoints: Number,
    opened: {
      type: Boolean,
      default: true,
    },
    wide: {
      type: Boolean,
      default: true,
    },
    nextText: {
      type: String,
      default: 'Продолжить',
    },
    startText: {
      type: String,
      default: 'Начать',
    },
    btnText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: this.opened,
    }
  },
  watch: {
    opened() {
      this.show = this.opened
    },
  },
  computed: {
    buttonText() {
      if (this.btnText) return this.btnText

      return (this.showPoints || this.showShare) ? this.nextText : this.startText
    },
    points() {
      return this.numberOfPoints < 10 ? `0${this.numberOfPoints}` : this.numberOfPoints
    },
  },
  methods: {
    buttonClick() {
      this.show = false
      this.$emit('close')
    },
    shareButtonClick() {
      this.$emit('share')
    },
  },
}
</script>
<style lang="scss" module>
  @import './LevelPopup.scss';
</style>
